import { Component, OnInit, Inject } from '@angular/core';

import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';



import { IHelp } from '@ebb-v2/ebb-integration';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
    selector: 'ebb-portal-app-sheet-help',
    templateUrl: './app-sheet-help.component.html',
    styles: [],
    standalone: false
})
export class AppSheetHelpComponent implements OnInit {

  public answer: SafeHtml;

  constructor(
    private sanitizer: DomSanitizer,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: IHelp,
    private refSheet: MatBottomSheetRef
  ) { 
  
    this.answer = this.sanitizeAnswer(this.data.answer);
   }

  ngOnInit() {  }
sanitizeAnswer(answer: string): SafeHtml {
  return this.sanitizer.bypassSecurityTrustHtml(answer);
}

  public onClickCloseHelp(): void {
    this.refSheet.dismiss();
  }

}
